import { AppBar, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import AddPatient from '../Header/AddPatient';
import Search from '../Header/Search';
import { PropTypes } from 'prop-types';
import Drawer from './Drawer/Drawer';
import LanguageContext from '../../contexts/languageContext';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import BreadCrumbs from '../BreadCrumbs';

const styles = makeStyles((theme) => ({
    container: {
        background: '#fff',
        padding: '14px 24px',
        borderBottom: '1px solid #e8ecf2',
        height: ({ isPatientList }) => (isPatientList ? '179px' : 'unset'),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '15px',
        '& img': {
            cursor: 'pointer'
        }
    },
    searchWrapper: {
        marginTop: '15px',
        '& > div:first-child': {
            margin: '0 !important'
        }
    },
    logo: {
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.06',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#232733',
        position: 'absolute',
        left: 'calc(50% - 21px)',
        // [theme.breakpoints.down(414)]: {
        //     left: (props) => !props.rtl && 'calc(50% - 56px)'
        // },
        [theme.breakpoints.down(450)]: {
            left: (props) => !props.rtl && 'calc(50% - 70px)'
        }
    },
    clinicName: {
        display: 'block !important',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100px',
        textAlign: 'start',
        unicodeBidi: 'plaintext',
        lineHeight: 2
        // direction: (props) => (props.rtl ? 'rtl' : 'ltr'),
    }
}));

const CustomAppBar = ({ isPatientList, title }) => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa', isPatientList });
    const workspace = useSelector((state) => state?.user?.workspace?.clinic);
    const { clinicId } = useParams();

    return (
        <AppBar color="transparent" elevation={0} position="sticky">
            <div className={classes.container}>
                <div className={classes.row}>
                    <div>
                        <Drawer />
                    </div>
                    <div className={classes.logo}>
                        {isPatientList ? (
                            <Link to={`/${clinicId}/select-clinic`} className={classes.clinicName}>
                                {workspace?.name}
                            </Link>
                        ) : (
                            title
                        )}
                    </div>
                    <div>{isPatientList ? <AddPatient /> : null}</div>
                </div>
                <BreadCrumbs />
                {isPatientList ? (
                    <div className={classes.searchWrapper}>
                        <Search />
                    </div>
                ) : null}
            </div>
        </AppBar>
    );
};
CustomAppBar.propTypes = {
    isPatientList: PropTypes.bool,
    title: PropTypes.string
};

export default CustomAppBar;
